import React, { useState, useEffect, MouseEventHandler, useRef } from 'react'
import { errorMap } from './BaseComponent'

import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from 'react-select';
import {
  SortableContainer,
  SortableContainerProps,
  SortableElement,
  SortEndHandler,
  SortableHandle,
} from 'react-sortable-hoc';

function arrayMove<T>(array: readonly T[], from: number, to: number) {
  const slicedArray = array.slice();
  slicedArray.splice(
    to < 0 ? array.length + to : to,
    0,
    slicedArray.splice(from, 1)[0]
  );
  return slicedArray;
}

const SortableMultiValue = SortableElement(
  (props: MultiValueProps<any>) => {
    // this prevents the menu from being opened/closed when the user clicks
    // on a value to begin dragging it. ideally, detecting a click (instead of
    // a drag) would still focus the control and toggle the menu, but that
    // requires some magic with refs that are out of scope for this example
    const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const innerProps = { ...props.innerProps, onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
  }
);

const SortableMultiValueLabel = SortableHandle(
  (props: MultiValueGenericProps) => <components.MultiValueLabel {...props} />
);

const SortableSelect = SortableContainer(Select) as React.ComponentClass<
  Props<any, true> & SortableContainerProps
>;

export default function NewMultiselectComponent({ API, select, selected, endpoint, table, isObject = false }) {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)

    const useDebounce = (callback, delay) => {
      const timeoutRef = useRef(null);
    
      useEffect(() => {
        return () => {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
        };
      }, []);
    
      const debouncedCallback = (...args) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
    
        timeoutRef.current = setTimeout(() => {
          callback(...args);
        }, delay);
      };
    
      return debouncedCallback;
    };

    const delaySearchCallback = useDebounce((term) => {
      getOptions(term)
    }, 500);
  
    const getOptions = (search) => {
      setLoading(true)
      let url = API+endpoint
      const params = {
        "limit": 100,
        "offset": 0,
        "query": search,
        archived: false
      }
  
      fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + sessionStorage.getItem('token')
          },
          body: JSON.stringify(params)
        })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        if (result.status.success) {
            let tempArray = []
            const filteredResults = table === "forms" ? result.data[table].filter((item) => item.category === "personal_data" || item.category === "device") : result.data[table]
            for (let i = 0; i < filteredResults.length; i++) {
                const element = filteredResults[i];
                tempArray.push(element)
            }
            // console.log(tempArray)
          setOptions(tempArray)
        } else {
          window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error) }}), true);
        }
        setLoading(false)
      }, (error) => {
        console.log(error)
        setLoading(false)
      })
    }
  
    useEffect(() => {
      getOptions()
      // eslint-disable-next-line
    }, [])

    const parsedSelected = selected.length > 0 && typeof selected[0] === "string"

    const onChange = (selectedOptions: OnChangeValue<any, true>) => {
      // console.log(selectedOptions)
      select(selectedOptions);
    }

    const onSortEnd: SortEndHandler = ({ oldIndex, newIndex }) => {
      const newValue = arrayMove(selected, oldIndex, newIndex);
      select(newValue);
      // console.log(
      //   'Values sorted:',
      //   newValue.map((i) => i.ident)
      // );
    };

    // console.log(options)
    
    return (
      // <Multiselect
      //   options={options}
      //   selectedValues={selected}
      //   onSelect={select}
      //   onRemove={select}
      //   isObject={isObject}
      //   displayValue="ident"
      //   groupBy={table === "forms" ? "category" : ""}
      // />
      <SortableSelect
        useDragHandle
        // react-sortable-hoc props:
        axis="xy"
        onSortEnd={onSortEnd}
        distance={4}
        // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
        getHelperDimensions={({ node }) => node.getBoundingClientRect()}
        // react-select props:
        isMulti
        options={options}
        value={!parsedSelected ? selected : selected.map((itm) => { return {ident: itm} }) }
        onChange={onChange}
        getOptionLabel={option => option.ident}
        getOptionValue={option => option.ident}
        components={{
          // @ts-ignore We're failing to provide a required index prop to SortableElement
          MultiValue: SortableMultiValue,
          MultiValueLabel: SortableMultiValueLabel,
        }}
        closeMenuOnSelect={false}
        onInputChange={(val) => { delaySearchCallback(val) }}
        isLoading={loading}
      />
    )
  }